// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Speiseplan ─── */

.speiseplan-container {
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: 2rem;
}

/* ─── Umschalter Essen / Reihenfolge ─── */

.speiseplan-switch {
  display: flex;
  background-color: var(--hellgruen);
  border-radius: 24px;
  padding: 4px;
  margin-bottom: 12px;
}

.speiseplan-switch-option {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 20px;
  background-color: transparent;
  color: var(--dunkelgruen);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95em;
  margin: 0;
  width: auto;
}

.speiseplan-switch-option .material-symbols-outlined {
  font-size: 1.2rem;
}

.speiseplan-switch-option.active {
  background-color: var(--dunkelgruen);
  color: var(--weiss);
}

body.Arbeit-Freizeit .speiseplan-switch-option.active {
  background-color: var(--orange);
}

body.Parlament .speiseplan-switch-option.active {
  background-color: var(--gelb);
}

body.Logistik .speiseplan-switch-option.active {
  background-color: var(--mittelblau);
}

/* ─── Reihenfolge-Ansicht ─── */

.reihenfolge-hinweis {
  font-family: 'Circular', sans-serif;
  font-size: 0.85em;
  color: var(--primary-dark);
  margin: 0 0 12px;
  text-align: center;
}

.reihenfolge-liste {
  font-family: 'Circular', sans-serif;
  font-size: 1em;
  color: var(--dunkelgruen);
  line-height: 1.7;
  margin: 0;
  padding-left: 1.6em;
}

.reihenfolge-liste li {
  padding-left: 4px;
}

.reihenfolge-liste li::marker {
  font-weight: bold;
}

/* ─── Wochentag-Tabs ─── */

.speiseplan-tabs {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 4px 0 12px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.speiseplan-tabs::-webkit-scrollbar {
  display: none;
}

.speiseplan-tab {
  flex: 0 0 auto;
  padding: 8px 16px;
  border-radius: 20px;
  border: 2px solid var(--dunkelgruen);
  background-color: transparent;
  color: var(--dunkelgruen);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95em;
  white-space: nowrap;
  margin: 0;
  width: auto;
}

.speiseplan-tab:hover {
  background-color: var(--hellgruen);
  opacity: 1;
}

.speiseplan-tab.active {
  background-color: var(--dunkelgruen);
  color: var(--weiss);
  border-color: var(--dunkelgruen);
}

/* Bereichsfarben für aktive Tabs */
body.Zeltbetreuung .speiseplan-tab.active {
  background-color: var(--dunkelgruen);
  border-color: var(--dunkelgruen);
}

body.Arbeit-Freizeit .speiseplan-tab.active {
  background-color: var(--orange);
  border-color: var(--orange);
}

body.Parlament .speiseplan-tab.active {
  background-color: var(--gelb);
  border-color: var(--gelb);
}

body.Logistik .speiseplan-tab.active {
  background-color: var(--mittelblau);
  border-color: var(--mittelblau);
}

body.Arbeit-Freizeit .speiseplan-tab:not(.active) {
  border-color: var(--orange);
  color: var(--orange);
}

body.Parlament .speiseplan-tab:not(.active) {
  border-color: var(--gelb);
  color: var(--gelb);
}

body.Logistik .speiseplan-tab:not(.active) {
  border-color: var(--mittelblau);
  color: var(--mittelblau);
}

/* ─── Mahlzeit-Karten ─── */

.speiseplan-meals {
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.meal-card {
  background-color: var(--hellgruen);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  position: relative;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.meal-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(100, 130, 2, 0.15);
}

.meal-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.meal-card-icon {
  font-size: 1.6rem;
  color: var(--dunkelgruen);
  line-height: 1;
}

body.Arbeit-Freizeit .meal-card-icon {
  color: var(--orange);
}

body.Parlament .meal-card-icon {
  color: var(--gelb);
}

body.Logistik .meal-card-icon {
  color: var(--mittelblau);
}

.meal-card-title {
  font-size: 1.3em;
  color: var(--dunkelgruen);
  margin: 0;
}

body.Arbeit-Freizeit .meal-card-title {
  color: var(--orange);
}

body.Parlament .meal-card-title {
  color: var(--gelb);
}

body.Logistik .meal-card-title {
  color: var(--mittelblau);
}

.meal-card-time {
  font-family: 'Circular', sans-serif;
  font-size: 0.85em;
  color: var(--primary-dark);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.meal-card-time .material-symbols-outlined {
  font-size: 1rem;
}

.meal-card-description {
  font-family: 'Circular', sans-serif;
  font-size: 1em;
  color: var(--dunkelgruen);
  line-height: 1.5;
}

/* ─── Leer-Zustand ─── */

.speiseplan-empty {
  text-align: center;
  padding: 40px 20px;
  color: var(--primary-dark);
  font-family: 'Circular', sans-serif;
}

.speiseplan-empty .material-symbols-outlined {
  font-size: 3rem;
  margin-bottom: 10px;
  opacity: 0.5;
}

.speiseplan-empty p {
  font-size: 0.95em;
}
`, "",{"version":3,"sources":["webpack://./src/components/speiseplan/Speiseplan.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,2CAA2C;;AAE3C;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,gCAAgC;;AAEhC;EACE,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* ─── Speiseplan ─── */\n\n.speiseplan-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding-bottom: 2rem;\n}\n\n/* ─── Umschalter Essen / Reihenfolge ─── */\n\n.speiseplan-switch {\n  display: flex;\n  background-color: var(--hellgruen);\n  border-radius: 24px;\n  padding: 4px;\n  margin-bottom: 12px;\n}\n\n.speiseplan-switch-option {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 20px;\n  background-color: transparent;\n  color: var(--dunkelgruen);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95em;\n  margin: 0;\n  width: auto;\n}\n\n.speiseplan-switch-option .material-symbols-outlined {\n  font-size: 1.2rem;\n}\n\n.speiseplan-switch-option.active {\n  background-color: var(--dunkelgruen);\n  color: var(--weiss);\n}\n\nbody.Arbeit-Freizeit .speiseplan-switch-option.active {\n  background-color: var(--orange);\n}\n\nbody.Parlament .speiseplan-switch-option.active {\n  background-color: var(--gelb);\n}\n\nbody.Logistik .speiseplan-switch-option.active {\n  background-color: var(--mittelblau);\n}\n\n/* ─── Reihenfolge-Ansicht ─── */\n\n.reihenfolge-hinweis {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.85em;\n  color: var(--primary-dark);\n  margin: 0 0 12px;\n  text-align: center;\n}\n\n.reihenfolge-liste {\n  font-family: 'Circular', sans-serif;\n  font-size: 1em;\n  color: var(--dunkelgruen);\n  line-height: 1.7;\n  margin: 0;\n  padding-left: 1.6em;\n}\n\n.reihenfolge-liste li {\n  padding-left: 4px;\n}\n\n.reihenfolge-liste li::marker {\n  font-weight: bold;\n}\n\n/* ─── Wochentag-Tabs ─── */\n\n.speiseplan-tabs {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding: 4px 0 12px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.speiseplan-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.speiseplan-tab {\n  flex: 0 0 auto;\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 2px solid var(--dunkelgruen);\n  background-color: transparent;\n  color: var(--dunkelgruen);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95em;\n  white-space: nowrap;\n  margin: 0;\n  width: auto;\n}\n\n.speiseplan-tab:hover {\n  background-color: var(--hellgruen);\n  opacity: 1;\n}\n\n.speiseplan-tab.active {\n  background-color: var(--dunkelgruen);\n  color: var(--weiss);\n  border-color: var(--dunkelgruen);\n}\n\n/* Bereichsfarben für aktive Tabs */\nbody.Zeltbetreuung .speiseplan-tab.active {\n  background-color: var(--dunkelgruen);\n  border-color: var(--dunkelgruen);\n}\n\nbody.Arbeit-Freizeit .speiseplan-tab.active {\n  background-color: var(--orange);\n  border-color: var(--orange);\n}\n\nbody.Parlament .speiseplan-tab.active {\n  background-color: var(--gelb);\n  border-color: var(--gelb);\n}\n\nbody.Logistik .speiseplan-tab.active {\n  background-color: var(--mittelblau);\n  border-color: var(--mittelblau);\n}\n\nbody.Arbeit-Freizeit .speiseplan-tab:not(.active) {\n  border-color: var(--orange);\n  color: var(--orange);\n}\n\nbody.Parlament .speiseplan-tab:not(.active) {\n  border-color: var(--gelb);\n  color: var(--gelb);\n}\n\nbody.Logistik .speiseplan-tab:not(.active) {\n  border-color: var(--mittelblau);\n  color: var(--mittelblau);\n}\n\n/* ─── Mahlzeit-Karten ─── */\n\n.speiseplan-meals {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: fadeIn 0.25s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.meal-card {\n  background-color: var(--hellgruen);\n  border-radius: 14px;\n  padding: 18px 20px;\n  text-align: left;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.meal-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 14px rgba(100, 130, 2, 0.15);\n}\n\n.meal-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.meal-card-icon {\n  font-size: 1.6rem;\n  color: var(--dunkelgruen);\n  line-height: 1;\n}\n\nbody.Arbeit-Freizeit .meal-card-icon {\n  color: var(--orange);\n}\n\nbody.Parlament .meal-card-icon {\n  color: var(--gelb);\n}\n\nbody.Logistik .meal-card-icon {\n  color: var(--mittelblau);\n}\n\n.meal-card-title {\n  font-size: 1.3em;\n  color: var(--dunkelgruen);\n  margin: 0;\n}\n\nbody.Arbeit-Freizeit .meal-card-title {\n  color: var(--orange);\n}\n\nbody.Parlament .meal-card-title {\n  color: var(--gelb);\n}\n\nbody.Logistik .meal-card-title {\n  color: var(--mittelblau);\n}\n\n.meal-card-time {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.85em;\n  color: var(--primary-dark);\n  margin-bottom: 6px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.meal-card-time .material-symbols-outlined {\n  font-size: 1rem;\n}\n\n.meal-card-description {\n  font-family: 'Circular', sans-serif;\n  font-size: 1em;\n  color: var(--dunkelgruen);\n  line-height: 1.5;\n}\n\n/* ─── Leer-Zustand ─── */\n\n.speiseplan-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--primary-dark);\n  font-family: 'Circular', sans-serif;\n}\n\n.speiseplan-empty .material-symbols-outlined {\n  font-size: 3rem;\n  margin-bottom: 10px;\n  opacity: 0.5;\n}\n\n.speiseplan-empty p {\n  font-size: 0.95em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
